"use strict";

var objKeys = require('./keys');
/**
 * Converts an object into an array of key, value arrays. Only the object's
 * own properties are used.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @param {Object} obj The object to extract from
 * @return {Array} An array of key, value arrays from the object's own properties.
 * @example
 *
 *      toPairs({a: 1, b: 2, c: 3}); //=> [['a', 1], ['b', 2], ['c', 3]]
 */
module.exports = function (obj) {
  if (obj === void 0) {
    obj = {};
  }
  var keys = objKeys(obj);
  var len = keys.length;
  var result = new Array(len);
  for (var i = 0; i < len; i++) {
    result[i] = [keys[i], obj[keys[i]]];
  }
  return result;
};